// Mock data for Swaarnim Book of Records website

export const heroData = {
  title: "WELCOME TO",
  subtitle: "Swaarnim Book Of Records",
  description: "Swaarnim Book Of Records is a premier skill registration and achievement recognition platform.",
  backgroundImage: "https://images.unsplash.com/photo-1570168007204-dfb528c6958f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxHYXRld2F5JTIwb2YlMjBJbmRpYSUyMHN1bnNldHxlbnwwfHx8fDE3NzUyMjU3NzN8MA&ixlib=rb-4.1.0&q=85"
};

export const infoCards = [
  {
    id: 1,
    title: "SWAARNIM BOOK OF RECORDS",
    icon: "award"
  },
  {
    id: 2,
    title: "PREMIER ACHIEVEMENT RECOGNITION PLATFORM",
    icon: "layers"
  }
];

export const aboutData = {
  title: "ABOUT US",
  content: [
    "Swaarnim Book Of Records is a distinguished platform dedicated to recognizing and documenting exceptional talents and achievements. We celebrate individuals who push the boundaries of human potential and showcase extraordinary skills.",
    "Every participant receives an official certificate of recognition — a prestigious mark of their unique accomplishment — acknowledged across various platforms and institutions.",
    "Our mission is to inspire excellence by providing a transparent and credible platform for documenting remarkable achievements. All operations are conducted with the highest standards of integrity and verification."
  ],
  buttonText: "Know More",
  buttonLink: "/about"
};

export const recordEvents = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1764408721535-2dcb912db83e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxhd2FyZCUyMGNlcmVtb255JTIwSW5kaWF8ZW58MHx8fHwxNzc1MjI1Nzc3fDA&ixlib=rb-4.1.0&q=85",
    title: "Records Events"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1773212902273-278c261a4c98?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxhd2FyZCUyMGNlcmVtb255JTIwSW5kaWF8ZW58MHx8fHwxNzc1MjI1Nzc3fDA&ixlib=rb-4.1.0&q=85",
    title: "Book Publish Event"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1766722568942-03cc930a1f7e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxjZXJ0aWZpY2F0ZSUyMHByZXNlbnRhdGlvbnxlbnwwfHx8fDE3NzUyMjU3ODN8MA&ixlib=rb-4.1.0&q=85",
    title: "Aighaba Dr. V Chitra"
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1772627876556-53976ddb3581?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxjZXJ0aWZpY2F0ZSUyMHByZXNlbnRhdGlvbnxlbnwwfHx8fDE3NzUyMjU3ODN8MA&ixlib=rb-4.1.0&q=85",
    title: "Appreciated Letter MLA"
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1759560245150-8dcbb7f01142?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxjZXJ0aWZpY2F0ZSUyMHByZXNlbnRhdGlvbnxlbnwwfHx8fDE3NzUyMjU3ODN8MA&ixlib=rb-4.1.0&q=85",
    title: "Records Events Gibor"
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1759560270562-468e8ba866e3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxjZXJ0aWZpY2F0ZSUyMHByZXNlbnRhdGlvbnxlbnwwfHx8fDE3NzUyMjU3ODN8MA&ixlib=rb-4.1.0&q=85",
    title: "Gibor Records Events"
  },
  {
    id: 7,
    image: "https://images.unsplash.com/photo-1773212902287-94f6df597e6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHxhd2FyZCUyMGNlcmVtb255JTIwSW5kaWF8ZW58MHx8fHwxNzc1MjI1Nzc3fDA&ixlib=rb-4.1.0&q=85",
    title: "Records Events"
  },
  {
    id: 8,
    image: "https://images.unsplash.com/photo-1739461081505-2bd70ac2942e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxhd2FyZCUyMGNlcmVtb255JTIwSW5kaWF8ZW58MHx8fHwxNzc1MjI1Nzc3fDA&ixlib=rb-4.1.0&q=85",
    title: "Records Events"
  },
  {
    id: 9,
    image: "https://images.pexels.com/photos/15256197/pexels-photo-15256197.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "Hon Dr. Sandip Gun Sir"
  }
];

export const recordHolders = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1764408721535-2dcb912db83e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxhd2FyZCUyMGNlcmVtb255JTIwSW5kaWF8ZW58MHx8fHwxNzc1MjI1Nzc3fDA&ixlib=rb-4.1.0&q=85",
    name: "MISS. NILANJANA",
    title: "SWAARNIM BOOK OF RECORDS\nRECORD HOLDER."
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1773212902273-278c261a4c98?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxhd2FyZCUyMGNlcmVtb255JTIwSW5kaWF8ZW58MHx8fHwxNzc1MjI1Nzc3fDA&ixlib=rb-4.1.0&q=85",
    name: "MR. UJUAL SARKAR",
    title: "SWAARNIM BOOK OF RECORDS\nRECORD HOLDER."
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1766722568942-03cc930a1f7e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxjZXJ0aWZpY2F0ZSUyMHByZXNlbnRhdGlvbnxlbnwwfHx8fDE3NzUyMjU3ODN8MA&ixlib=rb-4.1.0&q=85",
    name: "MR. ABHINADAN PUNDALIK",
    title: "SWAARNIM BOOK OF RECORDS\nRECORD HOLDER."
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1772627876556-53976ddb3581?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxjZXJ0aWZpY2F0ZSUyMHByZXNlbnRhdGlvbnxlbnwwfHx8fDE3NzUyMjU3ODN8MA&ixlib=rb-4.1.0&q=85",
    name: "RECORD HOLDER",
    title: "SWAARNIM BOOK OF RECORDS\nRECORD HOLDER."
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1759560245150-8dcbb7f01142?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxjZXJ0aWZpY2F0ZSUyMHByZXNlbnRhdGlvbnxlbnwwfHx8fDE3NzUyMjU3ODN8MA&ixlib=rb-4.1.0&q=85",
    name: "RECORD HOLDER",
    title: "SWAARNIM BOOK OF RECORDS\nRECORD HOLDER."
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1759560270562-468e8ba866e3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxjZXJ0aWZpY2F0ZSUyMHByZXNlbnRhdGlvbnxlbnwwfHx8fDE3NzUyMjU3ODN8MA&ixlib=rb-4.1.0&q=85",
    name: "RECORD HOLDER",
    title: "SWAARNIM BOOK OF RECORDS\nRECORD HOLDER."
  },
  {
    id: 7,
    image: "https://images.unsplash.com/photo-1773212902287-94f6df597e6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHxhd2FyZCUyMGNlcmVtb255JTIwSW5kaWF8ZW58MHx8fHwxNzc1MjI1Nzc3fDA&ixlib=rb-4.1.0&q=85",
    name: "RECORD HOLDER",
    title: "SWAARNIM BOOK OF RECORDS\nRECORD HOLDER."
  },
  {
    id: 8,
    image: "https://images.unsplash.com/photo-1739461081505-2bd70ac2942e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxhd2FyZCUyMGNlcmVtb255JTIwSW5kaWF8ZW58MHx8fHwxNzc1MjI1Nzc3fDA&ixlib=rb-4.1.0&q=85",
    name: "RECORD HOLDER",
    title: "SWAARNIM BOOK OF RECORDS\nRECORD HOLDER."
  },
  {
    id: 9,
    image: "https://images.pexels.com/photos/15256197/pexels-photo-15256197.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    name: "MR. INDIA",
    title: "SWAARNIM BOOK OF RECORDS\nRECORD HOLDER."
  }
];

export const navItems = [
  { id: 1, label: "HOME", path: "/" },
  { id: 2, label: "ABOUT US", path: "/about" },
  { id: 3, label: "RECORDS", path: "/records" },
  { id: 4, label: "HOW TO APPLY", path: "/how-to-apply" },
  { id: 5, label: "FAQ's", path: "/faqs" },
  { id: 6, label: "CONTACT US", path: "/contact" }
];

export const contactInfo = {
  email: "record@swaarnimbookofrecords.com",
  whatsapp: "447577300027"
};
